import {Pipe, PipeTransform} from '@angular/core';
import {ProviderDto} from '../../../Models/Purchases/Providers/provider.interface';

@Pipe({
  name: 'providers',
  standalone: false
})
export class ProvidersPipe implements PipeTransform {

  transform(items: ProviderDto[], filter: { local: number | null, departments?: number[] }): ProviderDto[] {

    if (!items || items.length === 0) {
      return [];
    }

    if (filter.local) {
      items = items.filter((item) => item.locales.length === 0 || item.locales.includes(filter.local || 0));
    }

    if (filter.departments && filter.departments.length > 0) {
      items = items.filter((item) => item.departamentos.length === 0 || item.departamentos.some((department) => filter.departments?.includes(department)));
    }

    return items;

  }

}
